<template >
  <div class="backgroundStyle">
    <v-container fluid v-if="!$vuetify.breakpoint.xs&&!loading">
      <v-layout column>
        <v-flex xs12>
          <div class="resultContainer">
            <v-layout align-center justify-center fill-height>
              <v-card
                min-width="200px"
                justify-center
                class="px-5 mx-5 text-xs-center rounded-card"
              >
                  <v-card-title justify-center>
                <v-img min-width="200px" max-width="300px" class="mt-2" :src="config.logo"></v-img>
                  </v-card-title>
                <v-card-text>

                  <v-flex class="grey--text" v-if="successfullyResetPassword">
                    <h3>Password Successfully Reset:</h3>
                    <h5>Please check your mail for your new credentials!</h5>
                    <br />
                  </v-flex>

                  <v-flex v-if="!resetPasswordCard">
                    <v-text-field
                      id="usernameId"
                      clearable
                      prepend-icon="mail"
                      color="primary"
                      label="Email/Username"
                      v-model="emailAddress"
                      v-on:keyup.enter="login"
                    ></v-text-field>
                    <br />
                    <v-text-field
                      id="passwordId"
                      prepend-icon="vpn_key"
                      color="primary"
                      :append-icon="show1 ? 'visibility' : 'visibility_off'"
                      :rules="[rules.min]"
                      :type="show1 ? 'text' : 'password'"
                      label="Password"
                      class="text-xs-center"
                      v-model="password"
                      @click:append="show1 = !show1"
                      v-on:keyup.enter="login"
                    ></v-text-field>
                    <v-btn
                      v-if="!loadingLogin"
                      id="loginButtonId"
                      dark
                      round
                      color="primary"
                      @click="login"
                    >Login</v-btn>
                    <v-btn v-else-if="loadingLogin" round disabled>
                          <span>Logging In </span>  <v-progress-circular
                          size="20"
                          indeterminate
                          color="white"
                        ></v-progress-circular></v-btn>
                    <!-- <v-layout v-if="loadingLogin" row justify-center>
                      <v-flex>
                        <vue-loaders-ball-spin-fade-loader
                          :key="loadingLogin"
                          color="grey"
                          scale="0.5"
                        ></vue-loaders-ball-spin-fade-loader>
                      </v-flex>
                    </v-layout> -->

                    <br />
                    <!-- <br> -->
                    <v-btn flat @click="resetPasswordCard=true">Forgot Password</v-btn>
                    <br />
                    <div class="danger-alert" v-html="error" />
                    <br />
                    <div v-show="errorMessage">
                      <span>Login Failed</span>
                    </div>
                    <div class="red--text" v-show="passwordError">
                      <span>Invalid Email/Password Combination</span>
                    </div>
                  </v-flex>

                  <v-flex v-if="resetPasswordCard&&!successfullyResetPassword">
                    <v-flex>
                      <h3 class="grey--text">Reset Password</h3>
                    </v-flex>
                    <v-text-field
                      clearable
                      color="primary"
                      prepend-icon="mail"
                      label="Email Address"
                      v-model="emailAddress"
                    ></v-text-field>
                    <br />
                    <v-btn
                      v-if="emailAddress"
                      dark
                      round
                      color="primary"
                      @click="resetPassword"
                    >RESET PASSWORD</v-btn>
                    <v-btn v-else disabled round>RESET PASSWORD</v-btn>
                    <br />
                    <v-btn round dark color="primary" @click="resetPasswordCard=false">Back</v-btn>
                    <br />
                    <div class="danger-alert" v-html="error" />
                    <br />
                    <div v-show="errorMessage">
                      <span>Login Failed</span>
                    </div>
                    <div class="red--text" v-show="emailVerifyFailed">
                      <span>Invalid Email Address</span>
                    </div>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container v-else-if="!loading" fluid style="height: 100vh;">
      <v-layout align-center justify-center fill-height>
        <v-flex xs10>
          <v-card class="rounded-card">
        <v-card-title justify-center>
                <v-img min-width="200px" max-width="300px" class="mt-2" :src="config.logo"></v-img>
                  </v-card-title>
                <v-card-text>

                  <v-flex class="grey--text" v-if="successfullyResetPassword">
                    <h3>Password Successfully Reset:</h3>
                    <h5>Please check your mail for your new credentials!</h5>
                    <br />
                  </v-flex>

                  <v-flex v-if="!resetPasswordCard">
                    <v-text-field
                      id="usernameId"
                      clearable
                      prepend-icon="mail"
                      color="primary"
                      label="Email/Username"
                      v-model="emailAddress"
                      v-on:keyup.enter="login"
                    ></v-text-field>
                    <br />
                    <v-text-field
                      id="passwordId"
                      prepend-icon="vpn_key"
                      color="primary"
                      :append-icon="show1 ? 'visibility' : 'visibility_off'"
                      :rules="[rules.min]"
                      :type="show1 ? 'text' : 'password'"
                      label="Password"
                      class="text-xs-center"
                      v-model="password"
                      @click:append="show1 = !show1"
                      v-on:keyup.enter="login"
                    ></v-text-field>
                    <v-btn
                      v-if="!loadingLogin"
                      id="loginButtonId"
                      dark
                      round
                      color="primary"
                      @click="login"
                    >Login</v-btn>
                    <v-btn v-else-if="loadingLogin" round disabled>
                          <span>Logging In </span>  <v-progress-circular
                          size="20"
                          indeterminate
                          color="white"
                        ></v-progress-circular></v-btn>
                    <!-- <v-layout v-if="loadingLogin" row justify-center>
                      <v-flex>
                        <vue-loaders-ball-spin-fade-loader
                          :key="loadingLogin"
                          color="grey"
                          scale="0.5"
                        ></vue-loaders-ball-spin-fade-loader>
                      </v-flex>
                    </v-layout> -->

                    <br />
                    <!-- <br> -->
                    <v-btn flat @click="resetPasswordCard=true">Forgot Password</v-btn>
                    <br />
                    <div class="danger-alert" v-html="error" />
                    <br />
                    <div v-show="errorMessage">
                      <span>Login Failed</span>
                    </div>
                    <div class="red--text" v-show="passwordError">
                      <span>Invalid Email/Password Combination</span>
                    </div>
                  </v-flex>

                  <v-flex v-if="resetPasswordCard&&!successfullyResetPassword">
                    <v-flex>
                      <h3 class="grey--text">Reset Password</h3>
                    </v-flex>
                    <v-text-field
                      clearable
                      color="primary"
                      prepend-icon="mail"
                      label="Email Address"
                      v-model="emailAddress"
                    ></v-text-field>
                    <br />
                    <v-btn
                      v-if="emailAddress"
                      dark
                      round
                      color="primary"
                      @click="resetPassword"
                    >RESET PASSWORD</v-btn>
                    <v-btn v-else disabled round>RESET PASSWORD</v-btn>
                    <br />
                    <v-btn round dark color="primary" @click="resetPasswordCard=false">Back</v-btn>
                    <br />
                    <div class="danger-alert" v-html="error" />
                    <br />
                    <div v-show="errorMessage">
                      <span>Login Failed</span>
                    </div>
                    <div class="red--text" v-show="emailVerifyFailed">
                      <span>Invalid Email Address</span>
                    </div>
                  </v-flex>
                </v-card-text>
      </v-card>
        </v-flex>
      </v-layout>
      
    </v-container>
    <v-container v-else fluid style="height: 100vh;">
      <v-layout fill-height justify-center align-center >
        <v-progress-circular color="white" indeterminate size="50"></v-progress-circular>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// import AuthenticationService from '@/services/AuthenticationService'
import Api from "@/services/Api";
import configData from "../../../config/config.json";

export default {
  data() {
    return {
      resetPasswordCard: false,
      newPassword: "",
      show1: false,
      successfullyResetPassword: false,
      email: "",
      emailAddress: "",
      errorMessage: false,
      passwordError: false,
      password: "",
      loading: true,
      error: null,
      loadingLogin: false,
      emailVerifyFailed: false,
      rules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Min 8 characters",
        emailMatch: () => "The email and password you entered don't match"
      }
    };
  },
  async created() {
    this.loading=true
    let config = configData;
    if(this.$route.params.organisationId){
      config = await this.fetchOrganisation(this.$route.params.organisationId)
    }
    this.config = config
    this.loading = false
     this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setPermission", null);
      this.$store.dispatch("setCustomerId", null);
      this.$store.dispatch("setCustomerId", null);
      this.$store.dispatch("setIsUserLoggedIn", false);
      this.$store.dispatch("setCurrentOrg", null);
      this.$store.dispatch("setOrgToken", null);
      this.$store.dispatch("setCurrentRoute", null);
      this.$store.dispatch("setOrganisations", null);
  },
  methods: {
    async fetchOrganisation(id){
      let result = null
      await Api().get('/organisation/customerPortal/'+id).then(res=>{
        result = res.data
      })
      return result
    },
    async login() {
      try {
        this.loadingLogin = true;
        this.passwordError = false;
        Api()
          .post("/login", {
            emailAddress: this.emailAddress,
            password: this.password
          })
          .then(async response => {
            if (
              response.status === 403 ||
              response.status === 401 ||
              response.status === 500
            ) {
              this.errorMessage = true;
              this.loadingLogin = false;
            }
            

            await this.$store.dispatch("setToken", response.data.token);
            await this.$store.dispatch("setUser", response.data.user);
            await this.$store.dispatch("setUserOrg", this.config);
            await this.$store.dispatch(
                  "setOrgToken",
                  this.config.token
                );

            this.$store.dispatch("setIsUserLoggedIn", true);
            await this.$router.push({ path: "/userPortal/dashboard" });
               
          })
          .catch(err => {
            this.passwordError = true;
            this.loadingLogin = false;
          });
      } catch (error) {
        this.error = error.response.data.error;
        this.loadingLogin = false;
      }
    },

    resetPassword() {
      this.passwordError = false
      this.emailVerifyFailed = false
      try {       
        Api()
          .post("/resetPassword", {
              emailAddress: this.emailAddress            
          })
          .then(response => {
            if (response.data=='Invalid') {
                  this.emailVerifyFailed = true;
                  this.passwordError = true;
                  this.resetPasswordCard = false;
            } else {
                  this.successfullyResetPassword = true;
                  this.resetPasswordCard = false;
            }
          })
          .catch(err => {
            this.emailVerifyFailed = true;
            this.passwordError = true;
          });
      } catch (error) {
        this.error = error.response.data.error;
        this.loadingLogin = false;
      }
    }
  }
};
</script>
<style scoped>
.resultContainer {
  height: 95vh;
}
.backgroundStyle {
  background-color: #333333;
}
/* body {background-color:"";} */
.item {
  min-height: 50px;
  min-width: 80px;
  margin: 10px;
}
.rounded-card {
  border-radius: 50px;
}
</style>

